//#region IMPORTS
import {
  HandThumbUpIcon,
  HandThumbDownIcon,
} from "@heroicons/react/24/outline";
import { InstoreOrder } from "../../models/instoreOrder";
import { Fragment } from "react";
import { Tooltip } from "react-tooltip";
//#endregion

//#region INTERFACE
interface Props {
  approveHandler: () => void;
  instoreOrder: InstoreOrder;
  hide?: boolean;
}
//#endregion

export default function InstoreOrdersTableRowActionApprove({
  approveHandler,
  instoreOrder,
  hide = false,
}: Props) {
  const isApproved = instoreOrder.approved !== false;
  return !hide ? (
    <Fragment>
      <button
        data-tooltip-content={isApproved ? "Approve order?" : "Decline order?"}
        data-tooltip-variant="dark"
        data-tooltip-place="left"
        data-tooltip-id={String(instoreOrder.id) + "approve"}
        data-tooltip-delay-show={500}
        className="flex items-center gap-4"
      >
        {isApproved ? (
          <HandThumbUpIcon
            className="h-5 w-5 text-emerald-500 hover:cursor-pointer hover:text-emerald-400"
            onClick={approveHandler}
            type="button"
          />
        ) : (
          <HandThumbDownIcon
            className="h-5 w-5 text-red-500 hover:cursor-pointer hover:text-red-400"
            onClick={approveHandler}
            type="button"
          />
        )}
      </button>
      <Tooltip id={String(instoreOrder.id) + "approve"} />
    </Fragment>
  ) : null;
}
